import React from 'react';
import { AssignmentDB } from '../../utils/assignmentsData';

/**
 * Renders children only when Assignment System feature is enabled for the current role.
 */
export default function AssignmentsGate({ currentRole, children }) {
  const isEnabled = AssignmentDB.isFeatureEnabled(currentRole);

  if (!isEnabled) {
    return (
      <div className="dashboard-container">
        <div className="bg-nn-white rounded-[14px] shadow-card overflow-hidden hover:shadow-md transition-shadow relative" style={{ padding: 40, textAlign: 'center' }}>
          <h2 className="text-2xl" style={{ fontWeight: 300, marginBottom: 16 }}>Assignment System</h2>
          <p className="text-text-muted" style={{ marginBottom: 20 }}>
            The Assignment System feature is not enabled for your role. Contact your administrator to enable it.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
